import React from 'react';

const DoneAllIcon = ({ color = '#4D4D4D', width = '15', height = '9', ...props }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M3.76667 8.01667L0 4.25L0.95 3.31667L4.71667 7.08333L3.76667 8.01667ZM7.53333 8.01667L3.76667 4.25L4.7 3.3L7.53333 6.13333L13.6667 0L14.6 0.95L7.53333 8.01667ZM7.53333 4.25L6.58333 3.31667L9.88333 0.0166667L10.8333 0.95L7.53333 4.25Z"
                fill={color}
            />
        </svg>
    );
};

export default DoneAllIcon;
